import React, { useEffect, useState, ChangeEvent } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Form } from "react-bootstrap";
import * as yup from "yup";

import { toast } from "react-toastify";
import { notifyError } from "../toast/Error";
import { notifySuccess } from "../toast/Success";
import useAxiosPost from "../../hooks/useAxiosPost";
import { removeSpacesFromString } from "../../helpers/strings";
const CreateNewBankAccountModalComponent: React.FC<
  CreateNewBankAccountModalComponentProp
> = ({ handleClose, show, intPkBankID }) => {
  const [
    postBotData,
    linkedBotsResponse,
    linkingError,
    linkingLoading,
    vlanMessage,
    linkingErrorCount,
  ] = useAxiosPost<CreateNewBankAccountProp>("superAdmin/createNewBankAccount");
  const UpdatePasswordForStaffValidationSchema = yup.object().shape({
    branchName: yup.string().required(),
    accountNumber: yup.string().required(),
    accountTitle: yup.string().required(),
    // intPkBankID: yup.string().required(),
  });

  const [branchName, setBranch] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [accountTitle, setAccountTitle] = useState<string>("");
  const handleCreateVlan = async (event: any) => {
    event.preventDefault();
    const dataToSend: CreateNewBankAccountProp = {
      branchName: branchName,
      accountNumber: accountNumber,
      accountTitle: accountTitle,
      intPkBankID: intPkBankID,
    };
    try {
      const isValid = await UpdatePasswordForStaffValidationSchema.validate(
        dataToSend
      );

      postBotData(dataToSend);
    } catch (error: any) {
      notifyError(error.message);
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (linkingError !== null && linkingErrorCount !== 0) {
      notifyError(linkingError);
    }
  }, [linkingError, linkingErrorCount]);
  useEffect(() => {
    if (linkedBotsResponse !== null) {
      const { message } = linkedBotsResponse;
      if (message) {
        notifySuccess(message || "Bank Created Successfully");
      }
      handleClose(true);
    }
  }, [linkedBotsResponse]);
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        show={show}
        onHide={() => {
          handleClose(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            Create New Bank Account <b>{""}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label> Account Title</Form.Label>
            <Form.Control
              placeholder={`Account Title`}
              type="text"
              value={accountTitle}
              onChange={(e) => {
                setAccountTitle(e.target.value.trimStart());
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label> Account Number</Form.Label>
            <Form.Control
              placeholder={`Account Number`}
              type="text"
              value={accountNumber}
              onChange={(e) => {
                setAccountNumber(removeSpacesFromString(e.target.value));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label> Branch Name</Form.Label>
            <Form.Control
              placeholder={`Branch Name`}
              type="text"
              value={branchName}
              onChange={(e) => {
                setBranch(e.target.value.trimStart());
              }}
            />
          </Form.Group>
          <div style={{ textAlign: "center" }}>
            <button
              onClick={handleCreateVlan}
              disabled={linkingLoading}
              className="button-primary"
              type="submit"
            >
              Submit
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default CreateNewBankAccountModalComponent;
